import { z } from 'zod';

export const feedbackSchema = z.object({
  _id: z.string(),
  type: z.string(),
  householdNumber: z.string(),
  user: z.object({
    id: z.string(),
    name: z.string(),
  }),
  title: z.string(),
  content: z.string(),
  image: z
    .object({
      name: z.string(),
      path: z.string(),
    })
    .nullable(),
  status: z.enum(['已回覆', '未回覆']),
  createdTime: z.string(),
  updatedTime: z.string(),
});

export const getFeedbackDataSchema = z.array(
  feedbackSchema.extend({
    status: z.enum(['已回覆', '未回覆']),
  })
);

export type GetFeedbackData = z.infer<typeof getFeedbackDataSchema>;

export type Feedback = z.infer<typeof feedbackSchema>;
